"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaginationStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var _colors_1 = require("../../../style/commons/_colors");
exports.usePaginationStyles = (0, styles_1.makeStyles)({
    ul: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
    },
    li: {
        margin: '0 4px',
        background: _colors_1.white,
        borderRadius: 4,
        padding: '5px 16px',
        '&:hover': {
            backgroundColor: _colors_1.lightBlue,
            cursor: 'pointer',
        },
    },
    selectedLi: {
        margin: '0 4px',
        background: _colors_1.lightBlue,
        borderRadius: 4,
        padding: '5px 16px',
    },
    selectedFont: {
        fontWeight: 700,
    },
    symbol: {
        position: 'absolute',
        left: '35.78%',
        right: '33.34%',
        top: '25%',
        bottom: '25%',
    },
    disabled: {
        margin: '0 4px',
        borderRadius: 4,
        padding: '5px 16px',
        background: _colors_1.white,
        cursor: 'not-allowed',
    },
    nav: {
        display: 'flex',
    },
});
